import React from 'react';
import PropTypes from 'prop-types';

import Cta from 'components/Core/Cta';
import { ACTION_NODE_LINK } from 'constants/Action';
import RichText from 'components/Core/RichText';

const OpeningTimes = ({
  title,
  activityTitle,
  availableDays,
  extraInfoBody,
  extraInfoButtonText,
  extraInfoButtonUrl,
  hideOpeningHours,
}) => {
  const getTimeframes = ({ startTime, endTime }) => (
    <div key={`${activityTitle}_${startTime}-${endTime}`}>
      {startTime} - {endTime}
    </div>
  );
  const checkContent = () => {
    return !hideOpeningHours || extraInfoBody || extraInfoButtonUrl;
  };

  return (
    <>
      {checkContent() && (
        <div className="bg-activity-sport-400 p-4 lg:p-8 rounded-base">
          {!hideOpeningHours && <h3 className="mb-4">{title}</h3>}
          {!hideOpeningHours &&
            availableDays.map(({ day, isCurrentDay, timeframes }, index) => (
              <div
                key={`${activityTitle}_${day}`}
                className={`flex items-start justify-between border-basic-700 border-opacity-10 py-2 ${
                  isCurrentDay && 'font-bold'
                } ${index !== 0 && 'border-t'}`}
              >
                <div className="capitalize">{day}</div>
                <div>{timeframes.map(getTimeframes)}</div>
              </div>
            ))}
          <div className={!hideOpeningHours && 'mt-4'}>
            {extraInfoBody && <RichText blockMargin={false} content={extraInfoBody} />}
            {extraInfoButtonUrl && (
              <div className="text-center">
                <Cta node={ACTION_NODE_LINK} href={extraInfoButtonUrl} showIcon={false}>
                  {extraInfoButtonText}
                </Cta>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

OpeningTimes.defaultProps = {
  title: 'Tijden',
  extraInfoBody: '',
  extraInfoButtonText: 'Bekijk meer',
  extraInfoButtonUrl: '',
  hideOpeningHours: false,
};

OpeningTimes.propTypes = {
  title: PropTypes.string,
  activityTitle: PropTypes.string.isRequired,
  availableDays: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.string.isRequired,
      isCurrentDay: PropTypes.bool.isRequired,
      timeframes: PropTypes.arrayOf(
        PropTypes.shape({
          startTime: PropTypes.string,
          endTime: PropTypes.string,
        }),
      ).isRequired,
    }),
  ).isRequired,
  extraInfoBody: PropTypes.string,
  extraInfoButtonText: PropTypes.string,
  extraInfoButtonUrl: PropTypes.string,
  hideOpeningHours: PropTypes.bool,
};

export default OpeningTimes;
